module.exports = __webpack_public_path__ + "ai-bot.e766c2a895afbeca53c90c6f22554798.svg";